import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function PainSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-16 px-4 md:px-6 max-w-3xl mx-auto" data-id="element-143">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="prose prose-lg md:prose-xl prose-stone mx-auto" data-id="element-144">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-charcoal mb-8 text-center" data-id="element-145">
          The gift problem nobody wants to say out loud
        </h2>

        <div className="space-y-6 text-warm-gray leading-relaxed" data-id="element-146">
          <p data-id="element-147">
            Kids today have more stuff than we ever did. And yet… the more stuff
            they have, the harder it is to give a gift that{' '}
            <span className="italic font-medium text-charcoal" data-id="element-148">lands</span>.
          </p>

          <p data-id="element-149">
            So you do what good grandmas do: you try. You shop. You pick
            something “nice.” You wrap it beautifully.
          </p>

          <p data-id="element-150">And then you watch the moment pass too quickly.</p>

          <p data-id="element-151">That’s not you being sensitive. That’s reality.</p>

          <div className="my-10 p-8 bg-white rounded-2xl shadow-sm border-l-4 border-coral relative overflow-hidden" data-id="element-152">
            <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-153">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor" className="text-coral" data-id="element-154">
                <path d="M10 11h-4v-2h4v2zm6 0h-4v-2h4v2zm6 0h-4v-2h4v2zm-6-4h-4v-2h4v2zm-6 0h-4v-2h4v2zm12 0h-4v-2h4v2zm-6 8h-4v-2h4v2zm-6 0h-4v-2h4v2zm12 0h-4v-2h4v2zm-6 4h-4v-2h4v2zm-6 0h-4v-2h4v2zm12 0h-4v-2h4v2z" data-id="element-155" />
              </svg>
            </div>
            <p className="text-xl md:text-2xl font-serif font-bold text-charcoal text-center relative z-10" data-id="element-156">
              "Objects compete with objects. <br className="hidden md:block" data-id="element-157" />
              <span className="text-coral" data-id="element-158">
                But moments compete with nothing.
              </span>
              "
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}